import { render, staticRenderFns } from "./prdAnaliseItemModal.vue?vue&type=template&id=665ba9b8&scoped=true&"
import script from "./prdAnaliseItemModal.vue?vue&type=script&lang=js&"
export * from "./prdAnaliseItemModal.vue?vue&type=script&lang=js&"
import style0 from "./prdAnaliseItemModal.vue?vue&type=style&index=0&id=665ba9b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665ba9b8",
  null
  
)

export default component.exports